export enum CornerstoneMouseButton {
  None = 0,
  Left = 1,
  Middle = 4,
  Right = 2,
}
